import {
  UserFieldsFragment,
  UserFieldsWithChannelsFragment,
} from '@/generated/graphql';
import { UserProfile } from '@/types';

const userFragment = (user: UserFieldsFragment): UserProfile => {
  return {
    id: user.id,
    reference: user.reference,
    userId: user.user_id,
    metadata: user.metadata?.length
      ? user.metadata?.map((meta) => ({
          key: meta.key,
          value: meta.value,
        }))
      : undefined,
  };
};

export const userWithChannelsFragment = (
  user: UserFieldsWithChannelsFragment
): UserProfile => {
  return {
    id: user.id,
    reference: user.reference,
    userId: user.user_id,
    channels: user.channels,
    metadata: user.metadata?.length
      ? user.metadata?.map((meta) => ({
          key: meta.key,
          value: meta.value,
        }))
      : undefined,
  };
};

export default userFragment;
